import React from "react";

const GRID_SIZE = 300;
const GRID_GAP = 3;

const cellStyle = {
  position: "relative",
  overflow: "hidden",
  background: "#e8e8e8",
  minHeight: 0,
  minWidth: 0,
};

const MediaGroupGrid = ({
  messages = [],
  renderCell,
  onOverflowClick,
}) => {
  const count = messages.length;
  const hasOverflow = count > 4;
  const visible = hasOverflow ? messages.slice(0, 4) : messages;
  const overflowCount = hasOverflow ? count - 3 : 0;

  const getLayoutStyle = () => {
    if (count === 2) {
      return {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "1fr",
        width: GRID_SIZE,
        height: Math.round(GRID_SIZE * 0.55),
      };
    }

    if (count === 3) {
      return {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "1fr 1fr",
        width: GRID_SIZE,
        height: GRID_SIZE,
      };
    }

    return {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "1fr 1fr",
      width: GRID_SIZE,
      height: GRID_SIZE,
    };
  };

  const getCellPlacement = (index) => {
    if (count === 2) {
      return {};
    }

    if (count === 3) {
      if (index === 0) {
        return { gridRow: "1 / 3", gridColumn: "1" };
      }
      if (index === 1) {
        return { gridRow: "1", gridColumn: "2" };
      }
      return { gridRow: "2", gridColumn: "2" };
    }

    return {};
  };

  return (
    <div
      style={{
        ...getLayoutStyle(),
        gap: GRID_GAP,
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      {visible.map((message, index) => {
        const isOverflowCell = hasOverflow && index === 3;

        return (
          <div
            key={message.id || message.message_id || `grid-${index}`}
            role={isOverflowCell ? "button" : undefined}
            tabIndex={isOverflowCell ? 0 : undefined}
            onClick={
              isOverflowCell
                ? () => onOverflowClick?.(messages)
                : undefined
            }
            onKeyDown={
              isOverflowCell
                ? (event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onOverflowClick?.(messages);
                  }
                }
                : undefined
            }
            style={{
              ...cellStyle,
              ...getCellPlacement(index),
              cursor: isOverflowCell ? "pointer" : undefined,
            }}
          >
            {renderCell(message, {
              compact: true,
              inGrid: true,
              isOverflowCell,
            })}
            {isOverflowCell && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(0, 0, 0, 0.45)",
                  backdropFilter: "blur(4px)",
                  WebkitBackdropFilter: "blur(4px)",
                  color: "#fff",
                  fontSize: 28,
                  fontWeight: 300,
                  pointerEvents: "none",
                }}
              >
                +{overflowCount}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MediaGroupGrid;
